export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-r from-background-50 to-background-100 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
                <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">投稿爆料</h2>
              </div>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4 max-w-lg">
                你有独家黑料？掌握一手证据？欢迎通过以下方式联系我们。
                911黑料网保护每一位爆料人的隐私安全，投稿内容经核实后将匿名发布。
                你的每一次爆料，都是对真相的守护。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="flex items-center gap-2 bg-background-200 rounded-lg px-4 py-2.5 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span className="text-sm text-foreground-700">tips@911heiliaowang.com</span>
                </div>
                <div className="flex items-center gap-2 bg-background-200 rounded-lg px-4 py-2.5 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                  <span className="text-sm text-foreground-700">911黑料网官方客服</span>
                </div>
              </div>
            </div>

            <div className="shrink-0 w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-500/10 border border-primary-500/20">
              <i className="ri-chat-smile-2-line text-primary-500 text-3xl md:text-4xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}